import { render, staticRenderFns } from "./serviceAcceptance.vue?vue&type=template&id=20261340"
import script from "./serviceAcceptance.vue?vue&type=script&lang=js"
export * from "./serviceAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports